import { object } from 'common/helpers'


export const initialState = {
  config: {},
  isInitialized: false,
  isCookiesError: false,
  isFetching: false,
  isFetched: false,
}

export const setFetching = (state, payload) =>
  ({ ...state, isFetching: payload, isFetched: !payload })

export const setInitialized = (state, payload) =>
  object.set(state, 'isInitialized', payload)

export const setCookiesError = (state, payload) =>
  object.set(state, 'isCookiesError', payload)
